import type { PetitionDraft } from '#src/app/shared/api/petitionDraft';

import type { machine as controlActor } from './actors/control/actor';
import type { machine as editVariantAActor } from './actors/editVariantA/actor';
import type { machine as editVariantBActor } from './actors/editVariantB/actor';
import type { machine as recommendationsActor } from './actors/recommendations/actor';

export type Draft = Partial<PetitionDraft>;

export const MediaTypes = { AI: 'AI_GENERATED', USER: 'USER_UPLOADED' } as const;

export type StateInput = object;

export type StateContext = { draft?: Draft | null };

export type StateEvents =
	| { type: 'back'; target?: null }
	| { type: 'submit'; draft?: Draft; target?: string | null }
	| { type: 'error' }
	| { type: 'sync_draft'; draft: Draft | null };

export type StateActions = {
	syncDraft: () => void;
	onSubmit: () => void;
	onError: () => void;
	// TODO: these actions should be removed after separating the control machine
	persistDraftType: () => void;
	persistRecommendationsDraftType: () => void;
	unsetDraftType: () => void;
	unsetRecommendationsDraftType: () => void;
};

export type StateGuards = {
	isControl: (args: { context: StateContext; event: StateEvents }, params?: unknown) => boolean;
	isVariant: (args: { context: StateContext; event: StateEvents }, params?: unknown) => boolean;
	isEditVariantA: (args: { context: StateContext; event: StateEvents }, params?: unknown) => boolean;
	isEditVariantB: (args: { context: StateContext; event: StateEvents }, params?: unknown) => boolean;
	// TODO: these guards should be removed after separating the control machine
	transitionTo: (_: unknown, params: { target: string }) => boolean;
	isUserDraft: (args: { context: StateContext; event: StateEvents }, params?: unknown) => boolean;
	isAiDraft: (args: { context: StateContext; event: StateEvents }, params?: unknown) => boolean;
	isRecommendationsVariantBDraft: (args: { context: StateContext; event: StateEvents }, params?: unknown) => boolean;
	isRecommendationsVariantBAiDraft: (args: { context: StateContext; event: StateEvents }, params?: unknown) => boolean;
	isRecommendationsVariantBUserDraft: (
		args: { context: StateContext; event: StateEvents },
		params?: unknown,
	) => boolean;
};

export type StateChildren = {
	controlActorId: 'controlActorSrc';
	recommendationsActorId: 'recommendationsActorSrc';
	editVariantAActorId: 'editVariantAActorSrc';
	editVariantBActorId: 'editVariantBActorSrc';
};

export type StateActors = {
	controlActorSrc: typeof controlActor;
	recommendationsActorSrc: typeof recommendationsActor;
	editVariantAActorSrc: typeof editVariantAActor;
	editVariantBActorSrc: typeof editVariantBActor;
};
